export const statusList = [
  { value: "approved", label: "Approved" },
  { value: "declined", label: "Declined" },
  { value: "pending", label: "Pending" },
];
export const employeeTypeList = [
  { value: "1", label: "Regular" },
  { value: "2", label: "Intern" },
];
